import { _js } from '@ifixit/localize';
import { faListUl } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const BulletListButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBulletList().run()}
         isActive={editor.isActive('bulletList')}
         isDisabled={!editor.can().toggleBulletList()}
         icon={<FontAwesomeIcon icon={faListUl} />}
         title={_js('Add a bulleted list')}
         shortcut={'shift+8'}
      />
   );
};
